import axios from "axios";

import useRootStore from "@/store/root";

import router from "@/router";

// Configuración de Axios
const axiosIns = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 0,
  headers: {
    "Access-Control-Allow-Origin": "*",
    "X-Requested-With": "XMLHttpRequest",
    // Accept: 'application/json',
    credentials: "include",
    mode: "cors",
  },
  withCredentials: false,
  // credentials: 'include',
});

// Agregar el token de autenticación si existe
if (localStorage.getItem("token")) {
  const token = localStorage.getItem("token");
  axiosIns.defaults.headers.common = { Authorization: `Bearer ${token}` };
}

export const aplicarInterceptors = () => {
  const root_store = useRootStore();

  // Interceptores de solicitud
  axiosIns.interceptors.request.use(
    (config) => {
      root_store.toggleLoading(true);

      return config;
    },
    (error) => {
      root_store.toggleLoading(false);
      return Promise.reject(error);
    }
  );

  // Interceptores de respuesta
  axiosIns.interceptors.response.use(
    (response) => {
      root_store.toggleLoading(false);

      return Promise.resolve(response);
    },
    (error) => {
      const { response } = error;
      root_store.toggleLoading(false);
      if (response && response.status === 401) {
        if (
          response.data.message === "Unauthenticated." ||
          response.data.message === "Unauthorized."
        ) {
          localStorage.removeItem("token");
          localStorage.removeItem("userData");
          localStorage.removeItem("usuarioId");
          localStorage.removeItem("habilidades");

          if (window.location.pathname !== "/login") {
            router.push({ name: "login" });
          }
        }

        if (response.data.message) {
          // Mostrar notificación de error (opcional)
          console.error(response.data.message);
        }
      }

      if (response && response.status === 404) {
        router.push({ name: "error-404" });
      }

      if (response && response.status === 419) {
        // Manejar error 419 (opcional)
      }

      if (response && response.status === 503) {
        router.push({ name: "show.mantenimiento" });
      }

      return Promise.reject(error);
    }
  );
};

window.axios = axiosIns;
// Exportar la instancia de Axios
export default axiosIns;
